import { AdminAuthGuard } from "./shared/guard/auth-guard-admin.service";
import { Component, OnInit } from "@angular/core";
import { ComponentsHelper } from "ng2-bootstrap/ng2-bootstrap";

@Component({
  selector: "wego-app",
  template: `<router-outlet></router-outlet>
  <wego-lodder [isLoading]="isLoading"></wego-lodder>
  `
})
export class AppComponent implements OnInit {
  private isLoading: boolean = false;
  private sub: any;

  constructor(private adminAuthGuard: AdminAuthGuard) {}

  ngOnInit() {
    this.HandleRoutingLoader();
  }

  HandleRoutingLoader() {
    this.sub = this.adminAuthGuard.GetLoaderStatus().subscribe(
      data => {
        this.isLoading = data;
      },
      err => {
        console.log(err);
      },
      () => {
        console.log("finished");
      }
    );
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app.component.ts